import { sentenceCase, splitCamelCase } from '@/utils/string';

type Primitive = string | number | boolean | null;

const SHORT_ACRONYM_LENGTH = 3;

const isPrimitive = (value: unknown): value is Primitive => value === null || ['string', 'number', 'boolean'].includes(typeof value);

/** A record that reads well as a label/value list: every value is a primitive or a list of primitives. */
export const isFlatRecord = (value: unknown): value is Record<string, Primitive | Primitive[]> =>
  typeof value === 'object' &&
  value !== null &&
  !Array.isArray(value) &&
  Object.values(value).every((entry) => isPrimitive(entry) || (Array.isArray(entry) && entry.every(isPrimitive)));

/** camelCase wire keys → sentence case; short all-lowercase keys are acronyms (pep → PEP). */
export const humanizeAnswerKey = (key: string): string => {
  if (/^[a-z]+$/.test(key) && key.length <= SHORT_ACRONYM_LENGTH) return key.toUpperCase();
  return sentenceCase(splitCamelCase(key));
};

export const formatAnswerValue = (value: Primitive | Primitive[]): string => {
  if (Array.isArray(value)) return value.length === 0 ? '—' : value.map((item) => formatAnswerValue(item)).join(', ');
  if (value === null || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value);
};
